<!-- Global top loading bar — shows on every page while any HTTP request is in flight -->
<div class="global-loading-bar" *ngIf="loading.loading()">
  <div class="gl-fill"></div>
</div>
<router-outlet />